import { render, staticRenderFns } from "./structure.vue?vue&type=template&id=a37a59da&"
import script from "./structure.vue?vue&type=script&lang=js&"
export * from "./structure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports